import React, { useState } from 'react';
import { Button, Card, Form, Input, Result, Spin } from 'antd';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { Link } from 'react-router-dom';
import { postApi } from '../../redux/rest/restSlice';
import { FORGOT_PASSWORD } from '../../constants/actionTypes';
import { LOGIN } from '../../constants/routes';
import { LOGO_URL, BRAND_NAME } from '../../constants/brand';
import { useDocumentTitle } from '../../components/PageHeader';

const ForgotPasswordScreen = () => {
    const [loading, setLoading] = useState(false);
    const [sentMessage, setSentMessage] = useState(null);

    const dispatch = useDispatch();
    useDocumentTitle('Forgot Password');

    const onFinish = (values) => {
        setLoading(true);
        dispatch(postApi({ endpoint: FORGOT_PASSWORD, payload: values }))
            .then(unwrapResult)
            .then((result) => {
                setSentMessage(result.message);
            })
            .catch(() => {
                // the axios interceptor already shows the error
            })
            .finally(() => setLoading(false));
    };

    return (
        <div className='login-page'>
            <Spin spinning={loading}>
                <Card bordered={false} className='login-card'>
                    <div className='login-container'>
                        <div className='login-brand'>
                            <img src={LOGO_URL} alt='GoGo Power' draggable={false} />
                            <span className='login-brand-text'>{BRAND_NAME}</span>
                        </div>

                        {sentMessage ? (
                            <Result
                                status='success'
                                title='Check your email'
                                subTitle={sentMessage}
                                extra={
                                    <Link to={LOGIN}>
                                        <Button type='primary' size='large' className='default-primary-btn'>
                                            Back to login
                                        </Button>
                                    </Link>
                                }
                            />
                        ) : (
                            <>
                                <div className='heading'>Forgot Password</div>
                                <div className='login-subheading'>
                                    Enter your registered email and we'll send you a link to reset your password.
                                </div>

                                <div className='login-form mt-30'>
                                    <Form
                                        name='forgot-password'
                                        layout='vertical'
                                        onFinish={onFinish}
                                        autoComplete='off'
                                        requiredMark={false}
                                    >
                                        <Form.Item
                                            label="Email"
                                            name="email_address"
                                            className="form-item"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Please enter your registered email",
                                                },
                                                {
                                                    type: 'email',
                                                    message: 'Please input a valid email'
                                                }
                                            ]}
                                        >
                                            <Input size='large' placeholder='Email' />
                                        </Form.Item>

                                        <div className="mt-20">
                                            <Form.Item>
                                                <Button
                                                    type="primary"
                                                    block
                                                    size='large'
                                                    htmlType="submit"
                                                    className='default-primary-btn'
                                                >
                                                    Send reset link
                                                </Button>
                                            </Form.Item>
                                        </div>
                                    </Form>
                                </div>

                                <div className='login-links'>
                                    <Link to={LOGIN}>Back to login</Link>
                                </div>
                            </>
                        )}
                    </div>
                </Card>
            </Spin>
        </div>
    );
};

export default ForgotPasswordScreen;
